export default "__VITE_ASSET__OFxsE2EK__"